export const contestCertificatePrintStyles = `
  * { box-sizing: border-box; }
  body {
    margin: 0;
    font-family: Arial, Helvetica, sans-serif;
    background: #efefef;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .page-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    padding: 0;
    background: #efefef;
  }
  .certificate-sheet {
    position: relative;
    width: 297mm;
    height: 210mm;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    border: 1.2mm solid #d8d8d8;
    padding: 22mm 26mm;
    color: #111;
  }
  .certificate-panel {
    width: 100%;
    min-height: 164mm;
    background: #fff;
    border-radius: 10mm;
    padding: 18mm 18mm 14mm;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .certificate-header {
    text-align: center;
    margin-top: 8mm;
  }
  .certificate-title {
    margin: 0;
    font-size: 18pt;
    font-weight: 700;
  }
  .certificate-subtitle {
    margin: 6mm 0 0;
    font-size: 10pt;
    font-weight: 700;
  }
  .certificate-body {
    max-width: 180mm;
    margin: 0 auto;
    text-align: center;
    line-height: 1.45;
    font-size: 12pt;
  }
  .certificate-body p { margin: 0; }
  .certificate-body p + p { margin-top: 4mm; }
  .certificate-footer {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 10mm;
    align-items: end;
  }
  .certificate-footer.no-medal {
    grid-template-columns: 1fr 1fr;
  }
  .signature-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2mm;
  }
  .signature-image {
    width: 78mm;
    max-width: 100%;
  }
  .signature-line {
    width: 70mm;
    border-top: 0.3mm solid #9a9a9a;
  }
  .signature-text {
    font-size: 8.5pt;
    text-align: center;
  }
  .medal-image {
    width: 34mm;
    display: block;
  }
  .logos-block {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4mm;
  }
  .letrus-logo {
    width: 30mm;
    display: block;
  }
  .olympics-logo {
    width: 38mm;
    display: block;
  }
  strong { font-weight: 700; }

  @page {
    size: A4 landscape;
    margin: 0;
  }

  @media print {
    body, .page-wrapper {
      background: none;
      padding: 0;
      width: auto;
      height: auto;
      min-height: 0;
    }
    .certificate-sheet {
      width: 297mm;
      height: 210mm;
      border: 1.2mm solid #d8d8d8;
      padding: 22mm 26mm;
    }
  }
`;
